// Library Methods
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import OperatingManualContent from "../OperatingManualContent/OperatingManualContent";
import GradientHeader from "src/components/shared/displays/GradientHeader/GradientHeader";

import manufacturerImg from "src/assets/images/operating-manual/appendix-a/manufacturer.png";

type ContactUsType = {
  title: string;
};

const ContactUs = ({ title }: ContactUsType) => {
  const { t } = useTranslation("operating-manual");

  return (
    <OperatingManualContent title={title}>
      <Box
        id=""
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <Typography>
          {t(
            "For technical assistance, comments or complaints, please contact"
          )}{" "}
          <span style={{ color: "#0066CC", fontWeight: 600 }}>
            support@retinalogik.ca
          </span>{" "}
          {t("or call")}{" "}
          <span style={{ color: "#0066CC", fontWeight: 600 }}>
            +1 (587) 905-5689
          </span>
          .
        </Typography>

        <GradientHeader header={t("Legal Manufacturer")} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            mx: "20px",
          }}
        >
          <Typography
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              mb: "8px",
            }}
          >
            <img src={manufacturerImg} width="30px" alt="manufacturer" />{" "}
            RetinaLogik Inc.
          </Typography>
          <Typography>3655 36 street NW</Typography>
          <Typography>Calgary, Alberta, T2L 1Y8, Canada</Typography>
        </Box>

        <GradientHeader header={t("About the Company")} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            mx: "20px",
          }}
        >
          <Typography>
            {t(
              "RetinaLogik Inc. is an award-winning company based out of Calgary, Alberta, Canada. RetinaLogik's team is working with top Albertan vision specialists to revolutionize vision testing technology."
            )}
          </Typography>
          <Typography>
            {t(
              "Their mission is to prevent vision loss for millions by making smarter vision screening more accessible for everyone, everywhere."
            )}
          </Typography>
          <Typography>
            {t("For more information, visit ")}
            <Link
              to="https://www.retinalogik.com/"
              target="_blank"
              style={{ color: "#0066CC", textDecoration: "underline" }}
            >
              www.retinalogik.com
            </Link>
            .
          </Typography>
        </Box>

        <GradientHeader header={t("UK REP")} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            mx: "20px",
            gap: "20px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography fontWeight={600}>UK REP</Typography>
            <Typography>Sotas Limited</Typography>
            <Typography>Unit 7 Merlins Court, Winch Lane</Typography>
            <Typography>Haverfordwest, Pembrokeshire, SA61 1SB</Typography>
            <Typography>United Kingdom</Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography fontWeight={600}>
              UK Responsible Person (UK-REP)
            </Typography>
            <Typography>Sotas Limited</Typography>
            <Typography>Unit 7 Merlins Court, Winch Lane</Typography>
            <Typography>Haverfordwest, Pembrokeshire, SA61 1SB</Typography>
            <Typography>United Kingdom</Typography>
            <Typography>+44 (0)1437 633027</Typography>
            <Typography>info@sotas.co.uk</Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography fontWeight={600}>{t("Importer")}</Typography>
            <Typography>Alex Jordan, Kestrel Ophthalmics Ltd.</Typography>
            <Typography>Unit 9, Cabot Business Village</Typography>
            <Typography>Holyrood Close, Creekmoor</Typography>
            <Typography>Poole, BH17 7BA</Typography>
            <Typography>United Kingdom</Typography>
          </Box>
        </Box>
      </Box>
    </OperatingManualContent>
  );
};

export default ContactUs;
